import React from 'react'

const Button = ({ active=false, onClick, Icon, title }) => {
    return (
        <button onClick={onClick} className={`button_component py-2 px-3 text-neutral-200 rounded bg-[#303847] hover:bg-[#203b69] ${active && '!bg-[#203b69] '} flex gap-2 items-center font-semibold text-sm`}>
            {
                Icon ? <span className="button__icon"><Icon color="white" /></span> : null
            }
            {
                title ? <span className="button__text">{title}</span> : null
            }
        </button>
    )
}

export default Button